module.exports = __webpack_public_path__ + "img/recruit1.6b2716e3.png";